import { useMediaQuery } from '@mui/material';
import { Close } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
import classnames from 'classnames';
import { forwardRef, useImperativeHandle, useRef } from 'react';
import { PopupActions } from 'reactjs-popup/dist/types';

import { Button } from '../../../Button/Button';
import { BaseModalDeprecated } from '../BaseModalDeprecated';

import styles from './Modal.module.scss';
import { Props } from './Modal.types';

/**
 * @deprecated use `Modal` instead
 */
export const ModalDeprecated = forwardRef<PopupActions, Props>(
  (
    {
      title,
      titleClassName,
      children,
      footerActionsRight,
      footerActionsLeft,
      icon,
      iconClassName,
      trigger,
      hideCloseAction,
      subtitle,
      containerClassName,
      ...rest
    }: Props,
    ref
  ) => {
    const innerRef = useRef<PopupActions>(null);

    useImperativeHandle<PopupActions | null, PopupActions | null>(ref, () => ({
      close: () => innerRef.current?.close(),
      open: () => innerRef.current?.open(),
      toggle: () => innerRef.current?.toggle(),
    }));
    const isMobile = useMediaQuery('(max-device-width: 768px)');

    return (
      <BaseModalDeprecated trigger={trigger} ref={innerRef} {...rest}>
        <div
          className={classnames(
            styles.container,
            { [styles.mobileContainer]: isMobile },
            containerClassName
          )}
        >
          <div className={classnames(styles.icon, iconClassName)}>{icon}</div>
          {!hideCloseAction && (
            <div className={classnames(styles.cross, { [styles.mobileCross]: isMobile })}>
              {
                <Button
                  variant="tertiary"
                  onClick={() => {
                    innerRef.current?.close();
                  }}
                  style={{
                    borderRadius: '0.5rem',
                  }}
                >
                  <Close />
                </Button>
              }
            </div>
          )}
          <div className={styles.header}>
            <div className={classnames(styles.title, titleClassName)}>{title}</div>
          </div>
          <div className={styles.subtitle}>{subtitle ?? <></>}</div>
          <div className={styles.content}>{children}</div>
          {(footerActionsLeft !== undefined || footerActionsRight !== undefined) && (
            <div className={styles.footer}>
              <div className={styles.sideFooter}>
                {footerActionsLeft?.map((footerAction, idx) => (
                  <div key={`actionFooter${idx}`} className={styles.footerButton}>
                    {footerAction}
                  </div>
                ))}
              </div>
              <div className={styles.sideFooter}>
                {footerActionsRight?.map((footerAction, idx) => (
                  <div key={`actionFooter${idx}`} className={styles.footerButton}>
                    {footerAction}
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </BaseModalDeprecated>
    );
  }
);
